// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.CustomCronofyCS {
  color: var(--ds-color-neutral-900, #0f172a);
  border-bottom: none;
}

span.CustomCronofyCS__title {
  font-size: 14px;
  font-weight: 400;
  border-bottom: none;
  line-height: 1.5rem;
  font-family:
    CircularXXWeb-Medium,
    Helvetica Neue,
    Helvetica,
    Arial,
    sans-serif;
}

div.CustomCronofyCS__profiles {
  border-bottom: none;
}

div.CustomCronofyCS__providers {
  flex-direction: column;
}

a.CustomCronofyCS__provider-auth {
  width: 360px;
}

div.CustomCronofyCS__status--active {
  border-bottom: none;
  font-size: 14px;
  font-weight: 200;
  font-family:
    CircularXXWeb-Medium,
    Helvetica Neue,
    Helvetica,
    Arial,
    sans-serif;
}

div.CustomCronofyCS__status--active > p {
  border-bottom: none;
  font-size: 14px;
  font-weight: normal;
  margin-top: 0px;
  color: var(--ds-color-neutral-400, #687281);
  font-family:
    CircularXXWeb-Medium,
    Helvetica Neue,
    Helvetica,
    Arial,
    sans-serif;
}

span.CustomCronofyCS__edit-toggle-text {
  font-size: 14px;
  font-weight: 500;
  color: #1260fd;
  border-bottom: none;
  font-family:
    CircularXXWeb-Medium,
    Helvetica Neue,
    Helvetica,
    Arial,
    sans-serif;
}

span.CustomCronofyCS__status-label {
  color: var(--ds-color-neutral-900, #0f172a);
}

div.CustomCronofyCS__profile > svg.CustomCronofyCS__provider-icon > path {
  fill: var(--ds-color-neutral-900, #0f172a);
}

svg.CustomCronofyCS__remove-icon > path {
  fill: var(--ds-color-neutral-900, #0f172a);
}

svg.CustomCronofyCS__edit-toggle-icon {
  display: none;
}

div.CustomCronofyCS__footer {
  position: absolute;
  margin-top: 0;
  right: 0;
}

svg.CustomCronofyCS__remove-icon path {
  fill: red;
}

svg.CustomCronofyAR__time-expander-button-icon > path {
  fill: var(--ds-color-neutral-900, #0f172a);
}

#cronofy-element-calendar-sync {
  margin-top: 22px;
  margin-left: 16px;
  width: 100%;
}

div.CenterMe {
  margin: auto;
}

div.CustomCronofyAR__label-row {
  color: var(--ds-color-neutral-900, #0f172a);
}

div.CustomCronofyAR__footer-spacer {
  display: none;
}

div.CustomCronofyAR__calendars {
  display: none;
}

button.CustomCronofyAR__submit {
  padding: 12px, 24px, 12px, 24px;
  border-radius: 5px;
  background: #1260fd;
}

div.CustomCronofyAR__confirmation {
  padding: 12px, 24px, 12px, 24px;
  border-radius: 5px;
  color: var(--ds-color-neutral-900, #0f172a);
}

div.CustomCronofyAR__footer {
  order: -1;
}
`, "",{"version":3,"sources":["webpack://./app/Calendar/styles.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB;;;;;cAKY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB;;;;;cAKY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C;;;;;cAKY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB;;;;;cAKY;AACd;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;AACX","sourcesContent":["div.CustomCronofyCS {\n  color: var(--ds-color-neutral-900, #0f172a);\n  border-bottom: none;\n}\n\nspan.CustomCronofyCS__title {\n  font-size: 14px;\n  font-weight: 400;\n  border-bottom: none;\n  line-height: 1.5rem;\n  font-family:\n    CircularXXWeb-Medium,\n    Helvetica Neue,\n    Helvetica,\n    Arial,\n    sans-serif;\n}\n\ndiv.CustomCronofyCS__profiles {\n  border-bottom: none;\n}\n\ndiv.CustomCronofyCS__providers {\n  flex-direction: column;\n}\n\na.CustomCronofyCS__provider-auth {\n  width: 360px;\n}\n\ndiv.CustomCronofyCS__status--active {\n  border-bottom: none;\n  font-size: 14px;\n  font-weight: 200;\n  font-family:\n    CircularXXWeb-Medium,\n    Helvetica Neue,\n    Helvetica,\n    Arial,\n    sans-serif;\n}\n\ndiv.CustomCronofyCS__status--active > p {\n  border-bottom: none;\n  font-size: 14px;\n  font-weight: normal;\n  margin-top: 0px;\n  color: var(--ds-color-neutral-400, #687281);\n  font-family:\n    CircularXXWeb-Medium,\n    Helvetica Neue,\n    Helvetica,\n    Arial,\n    sans-serif;\n}\n\nspan.CustomCronofyCS__edit-toggle-text {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1260fd;\n  border-bottom: none;\n  font-family:\n    CircularXXWeb-Medium,\n    Helvetica Neue,\n    Helvetica,\n    Arial,\n    sans-serif;\n}\n\nspan.CustomCronofyCS__status-label {\n  color: var(--ds-color-neutral-900, #0f172a);\n}\n\ndiv.CustomCronofyCS__profile > svg.CustomCronofyCS__provider-icon > path {\n  fill: var(--ds-color-neutral-900, #0f172a);\n}\n\nsvg.CustomCronofyCS__remove-icon > path {\n  fill: var(--ds-color-neutral-900, #0f172a);\n}\n\nsvg.CustomCronofyCS__edit-toggle-icon {\n  display: none;\n}\n\ndiv.CustomCronofyCS__footer {\n  position: absolute;\n  margin-top: 0;\n  right: 0;\n}\n\nsvg.CustomCronofyCS__remove-icon path {\n  fill: red;\n}\n\nsvg.CustomCronofyAR__time-expander-button-icon > path {\n  fill: var(--ds-color-neutral-900, #0f172a);\n}\n\n#cronofy-element-calendar-sync {\n  margin-top: 22px;\n  margin-left: 16px;\n  width: 100%;\n}\n\ndiv.CenterMe {\n  margin: auto;\n}\n\ndiv.CustomCronofyAR__label-row {\n  color: var(--ds-color-neutral-900, #0f172a);\n}\n\ndiv.CustomCronofyAR__footer-spacer {\n  display: none;\n}\n\ndiv.CustomCronofyAR__calendars {\n  display: none;\n}\n\nbutton.CustomCronofyAR__submit {\n  padding: 12px, 24px, 12px, 24px;\n  border-radius: 5px;\n  background: #1260fd;\n}\n\ndiv.CustomCronofyAR__confirmation {\n  padding: 12px, 24px, 12px, 24px;\n  border-radius: 5px;\n  color: var(--ds-color-neutral-900, #0f172a);\n}\n\ndiv.CustomCronofyAR__footer {\n  order: -1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
